import { store } from "app/store";
import { isImageType } from "features/files/fileSlice";

export function maxUploadSizeAllowed(type: string): number {
  if (!type) return -1;
  const settings = store.getState().appSettings.settings;
  if (settings && settings.maxmbs) {
    const s = settings.maxmbs[isImageType(type) ? 'img' : type.slice(0, 3)];
    if (typeof s === 'number') return s * 1_000_000;
  }
  return -1;
}

export function isToolAvailable(key?: string): boolean {
  if (!key) return false;
  const settings = store.getState().appSettings.settings;
  if (settings) {
    if (settings.tools.blocks?.includes(key)) return true;
    if (settings.tools.lists?.includes(key)) return true;
  }
  return false;
}

export function isRightGranted(key?: string): boolean {
  if (!key) return false;
  const settings = store.getState().appSettings.settings;
  if (settings && settings.rights) return settings.rights[key] ?? false;
  return false;
}
